import { isNumber } from "lodash";

/**
 * Филиалы, принадлежащие выбранным компаниям. Компания у филиала — объект
 * (`company.id`), а не число: раньше здесь проверялось `isNumber(company)`,
 * что всегда ложно, и фильтр «только компания» отдавал пустой список.
 *
 * Отдельный файл без store: тест импортирует только эту функцию.
 */
export function filterTaxiServiceIdsByCompanies(
	taxiServiceIds: number[],
	taxiServiceById: Record<number, { company?: { id: number } | null }>,
	companyIds: number[],
): number[] {
	return taxiServiceIds.filter((taxiServiceId) => {
		const companyId = taxiServiceById[taxiServiceId]?.company?.id;

		return isNumber(companyId) && companyIds.includes(companyId);
	});
}

export default filterTaxiServiceIdsByCompanies;
